module.exports = __webpack_public_path__ + "rumor-6bf80f556a71f7e3d1903c66328fb8f4.svg";